var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchema = function SvgSchema(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 12h-2a.91.91 0 0 0-.46.13L10 10.01V8.56l2.14-1.07A1 1 0 0 0 13 8h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1.44L9.85 7.51A.98.98 0 0 0 9 7h-.5V4H9a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.5v3H7a1 1 0 0 0-.86.51L4 6.44V5a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 .86-.51L6 8.56v1.45l-2.54 2.12A.91.91 0 0 0 3 12H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2.01l2.54-2.12c.14.08.29.13.46.13h2c.17 0 .32-.05.46-.13L12 12.99V15a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgSchema;